<core-data-grid
    #processLogGrid
    [dataSource]="processLogs"
    [columns]="processLogColumns"
    [props]="processLogGridProps">
</core-data-grid>